<!--
 * @Author: xing.huang
 * @Date: 2023-03-17 11:48:30
 * @LastEditTime: 2023-05-18 18:05:07
 * @LastEditors: xing.huang
 * @Description: 
 * @FilePath: \iMaster-Web\src\views\order\CompleteTask\TaskAudit.vue
 * 
-->
<template>
  <div class="task-audit" style="width:100%;heigh:100%;">
    <el-card class="table_searchbar">
      <el-row :gutter="20">
        <el-col :span="5">
          <div class="" @keydown.enter="btnSearch()">
            <span class="title">日期：</span>
            <el-date-picker style="max-width:180px" size="small" clearable value-format="yyyy-MM-dd" v-model="searchForm.date" type="date" placeholder="选择日期"></el-date-picker>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="">
            <span class="title">机组：</span>
            <el-select size="small" style="max-width:180px;" clearable v-model="searchForm.factoryModelId" placeholder="机组" filterable>
              <el-option v-for="item in workShopList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="" @keydown.enter="btnSearch()">
            <span class="title">工单号：</span>
            <el-input
              size="small"
              style="max-width:180px"
              clearable
              v-model="searchForm.productionBatchCode"
              @keyup.native="$event.target.value = $event.target.value.replace(/^\s+|\s+$/gm, '')"
              maxlength="32"
              placeholder="工单号"
            ></el-input>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="" @keydown.enter="btnSearch()">
            <span class="title">物料信息：</span>
            <el-select
              popper-class="width180"
              @visible-change="
                ev => {
                  if (!ev) {
                    remoteMethod('');
                  }
                }
              "
              :loading="loading"
              style="max-width: 200px"
              clearable
              :remote-method="query => remoteMethod(query)"
              v-model="searchForm.materialId"
              filterable
              placeholder="物料编码"
              remote
            >
              <el-option v-for="item in materialList" :key="item.materialId" :label="`${item.materialName}/${item.materialCode}`" :value="item.materialId"></el-option>
            </el-select>
          </div>
        </el-col>

        <el-col :span="4">
          <div style="text-align:right">
            <a style="margin-right: 12px;cursor: pointer;font-size: 12px;" @click="toggleShowMore">
              {{ showMore ? "收起" : "展开" }}
              <i :class="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
            </a>
            <el-button size="mini" icon="el-icon-search" type="primary" @click="btnSearch()">查询</el-button>
            <el-button size="mini" icon="el-icon-refresh" @click="clearSearch">重置</el-button>
          </div>
        </el-col>
      </el-row>
      <el-collapse-transition>
        <div v-show="showMore">
          <el-row :gutter="20">
            <el-col :span="5">
              <div class="">
                <span class="title">状态：</span>
                <el-select size="small" style="max-width:180px;" clearable v-model="searchForm.ackStatus" placeholder="状态" filterable>
                  <el-option :key="0" label="未确认" :value="0"></el-option>
                  <el-option :key="1" label="已确认" :value="1"></el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :span="5">
              <div class="" @keydown.enter="btnSearch()">
                <span class="title">订单号：</span>
                <el-input size="small" style="max-width:180px" clearable v-model="searchForm.erpBusinessOrderCode" maxlength="32" placeholder="订单号"></el-input>
              </div>
            </el-col>
            <el-col :span="10">
              <div class="">
                <span class="title" style="width: 148px;">执行人/执行组：</span>
                <el-select size="small" style="max-width:100px;" v-model="searchForm.userType" placeholder="状态" filterable>
                  <el-option :key="0" label="执行人" :value="0"></el-option>
                  <el-option :key="1" label="执行组" :value="1"></el-option>
                </el-select>
                <el-select v-if="searchForm.userType == 0" size="small" style="max-width:180px;" clearable v-model="searchForm.workerId" placeholder="执行人" filterable>
                  <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
                <el-select v-if="searchForm.userType == 1" size="small" style="max-width:180px;" clearable v-model="searchForm.executionGroupId" placeholder="执行组" filterable>
                  <el-option v-for="item in executionGroupList" :key="item.id" :label="item.groupName" :value="item.id"></el-option>
                </el-select>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-collapse-transition>
    </el-card>
    <el-card class="table-card">
      <div class="table_common_operbar">
        <el-row>
          <el-button type="primary" size="small" @click="auditAllTask" :disabled="selectList.length == 0">批量确认</el-button>
        </el-row>
      </div>
      <el-table :data="tableData" stripe style="width: 100%;" class="deviceTable" @selection-change="handleSelectionChange">
        <el-table-column width="80" type="selection" :selectable="allowSelect"></el-table-column>
        <el-table-column prop="factoryModelName" label="机组" min-width="90" show-overflow-tooltip></el-table-column>
        <el-table-column prop="productionBatchCode" label="工单号" min-width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="erpBusinessOrderCode" label="订单号" min-width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="ackStatus" label="状态" min-width="80" show-overflow-tooltip>
          <template slot-scope="scope">
            <span :style="{ color: scope.row.ackStatus == 0 ? 'red' : '' }"> {{ scope.row.ackStatus == 0 ? "未确认" : "已确认" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="materialCode" label="物料编码" min-width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="materialName" label="物料名称" min-width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="materialQualityName" label="材质" min-width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="procedureName" label="工序名称" min-width="90" show-overflow-tooltip></el-table-column>
        <el-table-column prop="name" label="执行人/执行组" min-width="100"></el-table-column>
        <el-table-column prop="gmtCreate" label="报工时间" min-width="180"></el-table-column>
        <el-table-column prop="qualifiedProcessCount" label="合格数" min-width="70"></el-table-column>
        <el-table-column prop="actualFinishedAmount" label="实际合格数" min-width="70"></el-table-column>
        <el-table-column prop="unqualifiedProcessCount" label="不合格数" min-width="70"></el-table-column>
        <el-table-column prop="actualUnqualifiedProcessCount" label="实际不合格数" min-width="70"></el-table-column>
        <el-table-column prop="operationalWasteCount" label="工废数" min-width="70"></el-table-column>
        <el-table-column prop="actualOperationalWasteCount" label="实际工废数" min-width="70"></el-table-column>
        <el-table-column prop="materialWasteCount" label="料废数" min-width="70"></el-table-column>
        <el-table-column prop="actualMaterialWasteCount" label="实际料废数" min-width="70"></el-table-column>
        <el-table-column v-for="item in extendedFieldList" show-overflow-tooltip :key="item.id" :prop="item.id + ''" :label="item.propertyName" min-width="100"></el-table-column>
        <el-table-column label="操作" fixed="right" width="80" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-button type="text" @click="showUpdataCount(scope.row, true)" size="small">确认</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="page" v-if="tableData.length > 0">
        <div class="total_page">
          <span> 共{{ tableTotalPage }}条 </span>
        </div>
        <div style="margin-top:10px;text-align:right; margin-bottom: 20px;">
          <el-pagination
            background
            @size-change="sizeChange"
            layout=" sizes, prev, pager, next, jumper"
            :page-count="tableTotalPage"
            :page-sizes="[10, 20, 30, 50, 100]"
            :page-size.sync="pageSize"
            :total="tableTotalPage"
            @current-change="pageChange"
            :current-page.sync="tableCurrentPage"
          >
          </el-pagination>
        </div>
      </div>
    </el-card>
    <el-dialog title="修改数量" center :visible.sync="isShowDialog" width="50%" :close-on-click-modal="false">
      <div style="margin-top:-14px;margin-bottom:26px">
        <el-form ref="form" :model="form" :rules="rules">
          <el-table style="width:80%;margin-left:10%" :data="dataList" stripe>
            <el-table-column label="内容" prop="text" min-width="100">
              <template slot-scope="scope">
                <el-form-item>
                  <el-form-item>
                    <span style="position: relative;top: 12px;color: #475569;font-size: 16px;font-family: 'MiSans-Regular';">{{ scope.row.text }}</span>
                  </el-form-item>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="报工数" prop="actualAmount" min-width="150">
              <template slot-scope="scope">
                <el-form-item>
                  <el-input disabled v-model="scope.row.count" :maxlength="9" style="width:80px"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="实际数" prop="actualCount" min-width="150">
              <template slot-scope="scope">
                <el-form-item :prop="`dataList[${scope.$index}].actualCount`" :rules="rules.actualCount">
                  <el-input v-model="scope.row.actualCount" :maxlength="9" style="width:80px"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
      </div>
      <div style="text-align: center;">
        <el-button size="small" @click="isShowDialog = false" style="margin-left: 20px;">取 消</el-button>
        <el-button type="primary" size="small" @click="updataCount">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "TaskAudit",
  data() {
    return {
      isShowDialog: false,
      showMore: false,
      loading: false,
      materialList: [],
      workShopList: [],
      executionGroupList: [],
      userList: [],
      extendedFieldList: [],
      W: false,
      btnPressType: 0, //按钮类型： 0-默认 1-查询 2-重置 3-分页
      searchFormTemp: "", //临时搜索数据
      searchForm: {
        ackStatus: null,
        date: "",
        executionGroupId: null,
        factoryModelId: null,
        materialId: null,
        userType: 0,
        workerId: null,
        erpBusinessOrderCode: ""
      },
      searchCopy: {
        ackStatus: null,
        date: "",
        executionGroupId: null,
        factoryModelId: null,
        materialId: null,
        userType: 0,
        workerId: null
      },
      form: {
        dataList: [],
        planId: null
      },
      dataList: [],
      selectList: [],
      rules: {
        actualCount: [
          { required: true, message: "请输入数量", trigger: "blur" },
          {
            validator(rule, value, callback) {
              if (Number(value) >= 0) {
                callback();
              } else {
                callback(new Error("数量不能小于零"));
              }
            },
            trigger: "blur"
          }
        ],
        actualUnqualifiedProcessCount: [
          { required: true, message: "请输入有效报废数", trigger: "blur" },
          {
            validator(rule, value, callback) {
              if (Number(value) >= 0) {
                callback();
              } else {
                callback(new Error("数量不能小于零"));
              }
            },
            trigger: "blur"
          }
        ]
      },
      tableData: [],
      pageSize: 10,
      tableCurrentPage: 1,
      tableTotalPage: 2,
      data: {
        token: localStorage.getItem("token")
      },
      permission: JSON.parse(localStorage.getItem("permission"))
    };
  },

  mounted: function() {
    this.initTable();
    this.loadWorkShopList();
    this.loadUserList();
    this.loadExecutionGroup();
    this.remoteMethod();
    this.getPropertyExtendList();
    let w = document.documentElement.clientWidth || document.body.clientWidth;
    w >= 1900 ? (this.W = true) : (this.W = false);
  },

  computed: {
    span() {
      return this.W ? 5 : 7;
    }
  },
  filters: {},

  methods: {
    allowSelect(row, index) {
      return row.ackStatus == 0;
    },
    handleSelectionChange(ev) {
      this.selectList = ev.map(item => item.id);
    },
    async getPropertyExtendList() {
      let { code, data } = await this.$RequestUtil.getAsync({ url: "/api/property-extend/list", type: "sync", params: { type: 0 } });
      data.forEach(item => {
        item.propertyValue = null;
      });
      this.extendedFieldList = data;
    },
    toggleShowMore() {
      this.showMore = !this.showMore;
    },

    async loadWorkShopList() {
      let { data, code, msg, message } = await this.$RequestUtil.getAsync({ url: "/api/factoryModel/getWorkShopList", params: {} });
      if (code == 0) {
        this.workShopList = data;
      } else {
        this.$message.error(msg || message);
      }
    },

    async loadUserList() {
      let { data, code, msg, message } = await this.$RequestUtil.getAsync({ url: "/api/select/listWorker", params: {} });
      if (code == 0) {
        this.userList = data;
      } else {
        this.$message.error(msg || message);
      }
    },

    async loadExecutionGroup() {
      let { data, code, msg, message } = await this.$RequestUtil.postAsync({ url: "/api/executionGroup/list", params: {} });
      if (code == 0) {
        this.executionGroupList = data;
      } else {
        this.$message.error(msg || message);
      }
    },

    async remoteMethod(webSearchStr) {
      this.loading = true;
      let { data } = await this.$RequestUtil.getAsync({ url: "/api/select/listMaterial", type: "sync", params: { webSearchStr } });
      this.materialList = data;
      this.loading = false;
    },

    sizeChange(ev) {
      this.pageSize = ev;
      this.search();
    },

    showUpdataCount(rowData) {
      this.form.planId = rowData.planId;
      let dataList = [
        {
          text: "合格",
          count: rowData.qualifiedProcessCount,
          actualCount: rowData.actualFinishedAmount,
          id: rowData.id,
          actualSpoiledProcessCount: rowData.actualSpoiledProcessCount
        },
        {
          text: "不合格",
          count: rowData.unqualifiedProcessCount,
          actualCount: rowData.actualUnqualifiedProcessCount,
          id: rowData.id
        },
        {
          text: "工废",
          count: rowData.operationalWasteCount,
          actualCount: rowData.actualOperationalWasteCount,
          id: rowData.id
        },
        {
          text: "料废",
          count: rowData.materialWasteCount,
          actualCount: rowData.actualMaterialWasteCount,
          id: rowData.id
        }
      ];
      this.dataList = dataList;
      this.form.dataList = dataList;
      this.isShowDialog = true;
      if (this.$refs["form"]) {
        this.$refs["form"].clearValidate();
      }
    },
    auditAllTask() {
      this.$confirm("此操作将批量确认报工任务, 确认后无法撤销，是否继续?", "提示", {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$RequestUtil.post({
          url: "/api/productionPlanDetail/batchAck",
          type: "sync",
          params: {
            detailList: this.selectList
          },
          success: res => {
            if (res.code == 0) {
              this.$message.success("批量确认成功");
              this.search();
              this.selectList = [];
            } else {
              this.$message.error(res.message || res.msg);
            }
          }
        });
      });
    },

    updataCount() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          let json = {
            id: this.dataList[0].id,
            actualAmount: Number(this.dataList[0].actualCount),
            actualSpoiledProcessCount: Number(this.dataList[0].actualSpoiledProcessCount),
            actualUnqualifiedProcessCount: Number(this.dataList[1].actualCount),
            actualOperationalWasteCount: Number(this.dataList[2].actualCount),
            actualMaterialWasteCount: Number(this.dataList[3].actualCount)
          };
          let dataList = [json];
          this.$RequestUtil.post({
            url: "/api/productionPlanDetail/ack",
            type: "sync",
            params: {
              planId: this.form.planId,
              dataList
            },
            success: res => {
              if (res.code == 0) {
                this.isShowDialog = false;
                this.$message.success("修改成功");
                this.search();
              } else {
                this.$message.error(res.message || res.msg);
              }
            }
          });
        }
      });
    },

    btnSearch: function() {
      this.tableCurrentPage = 1;
      this.btnPressType = 1;
      this.searchCopy = commonUtils.cloneObj(this.searchForm);
      this.search();
    },

    clearSearch() {
      let form = this.searchForm;
      this.btnPressType = 2;
      form.materialId = null;
      form.factoryModelId = null;
      form.productionBatchCode = "";
      form.ackStatus = null;
      form.date = "";
      form.executionGroupId = null;
      form.userType = 0;
      form.workerId = null;
      form.erpBusinessOrderCode = "";
      this.searchCopy = {
        ackStatus: null,
        date: "",
        executionGroupId: null,
        factoryModelId: null,
        materialId: null,
        userType: 0,
        workerId: null,
        erpBusinessOrderCode: ""
      };
    },

    search: function() {
      this.searchForm = commonUtils.cloneObj(this.searchCopy);
      let temp;
      switch (this.btnPressType) {
        case 1:
          temp = commonUtils.cloneObj(this.searchForm);
          this.searchFormTemp = commonUtils.cloneObj(temp);
          break;
        case 0:
          temp = {
            ackStatus: null,
            date: "",
            executionGroupId: null,
            factoryModelId: null,
            materialId: null,
            userType: 0,
            workerId: null,
            erpBusinessOrderCode: ""
          };
          break;
        case 2:
          temp = this.searchFormTemp;
          break;
        case 3:
          temp = this.searchFormTemp;
          break;
      }
      let params = {
        pageNum: this.tableCurrentPage,
        pageSize: this.pageSize,
        materialId: temp.materialId,
        factoryModelId: temp.factoryModelId,
        productionBatchCode: temp.productionBatchCode,
        ackStatus: temp.ackStatus,
        date: temp.date,
        executionGroupId: temp.executionGroupId,
        workerId: temp.workerId,
        erpBusinessOrderCode: temp.erpBusinessOrderCode
      };
      if (temp.userType == 0) {
        delete params.executionGroupId;
      } else {
        delete params.workerId;
      }
      this.$RequestUtil.post({
        url: "/api/productionPlanDetail/ack/list",
        type: "sync",
        params,
        success: res => {
          if (res.msg == this.$Global.RESPONSE.SUCCESS) {
            // let extendedFieldList = []
            // res.data.list.forEach(item=>{
            //     for(let o in item.extendMap){
            //         if(!extendedFieldList.includes(o)){
            //             extendedFieldList.push(o)
            //         }
            //        item[`${o}`] = item.extendMap[o]
            //     }
            // })
            // this.extendedFieldList = extendedFieldList

            res.data.list.forEach(item => {
              for (let o in item.extendMap) {
                item[`${o}`] = item.extendMap[o];
              }
            });
            this.tableData = res.data.list;
            this.tableTotalPage = res.data.total;

            if (res.data.total == 0 && this.fristLoad) {
              this.$message.warning("查询不到符合条件的数据");
            }
            this.fristLoad = true;
          } else {
            this.$message.error(res.message || res.msg);
          }
        }
      });
    },

    pageChange: function(targetPage) {
      this.tableCurrentPage = targetPage;
      this.btnPressType = 3;
      this.search();
    },

    parseCreate(rowData) {
      if (rowData.gmtCreate) {
        return commonUtils.timestampToDate(rowData.gmtCreate, true);
      } else {
        return "";
      }
    },

    initTable: function() {
      this.search();
    }
  }
};
</script>

<style scoped>
.el-row {
  margin-bottom: 20px;

  & :last-child {
    margin-bottom: 0;
  }
}
.page {
  display: flex;
  justify-content: flex-end;
}

@media screen and (max-width: 1450px) {
  .page {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 30px;
  }
}

.total_page {
  margin-top: 14px;
  margin-right: 26px;
  color: #606266;
  font-size: 14px;
}
</style>
<style>
.width180 {
  width: 180px;
}
.task-audit .el-table__header-wrapper .el-checkbox__input {
  margin-left: 4px;
}
</style>



// WEBPACK FOOTER //
// src/views/order/CompleteTask/TaskAudit.vue